import script from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=cf7be1bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf7be1bc"]])

export default __exports__